import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import styles from './unordered-list.module.scss.js';
import { validateSurface } from '../../globals.js';

/**
 * @component UnorderedList
 * @package Lists
 * @document ../_docs/code/UnorderedList.editor.tsx
 * @document ../_docs/code/UnorderedList.snippet.tsx
 * @document ../_docs/code/UnorderedList.import.tsx
 */
const UnorderedList = (_a) => {
    var { id, children, ariaLabel, 'aria-label': arialabel, surface: surfaceProp = 'lightPrimary', color, size = 'large', spacing = 'standard' } = _a, rest = __rest(_a, ["id", "children", "ariaLabel", 'aria-label', "surface", "color", "size", "spacing"]);
    const surface = validateSurface(surfaceProp);
    const unorderedListStyles = [
        styles.unorderedList,
        styles[surface.toLowerCase()],
    ];
    switch (size) {
        case 'micro':
            unorderedListStyles.push(styles.micro);
            break;
        case 'small':
            unorderedListStyles.push(styles.small);
            break;
        case 'medium':
            unorderedListStyles.push(styles.medium);
            break;
        case 'large':
            unorderedListStyles.push(styles.large);
            break;
    }
    if (color === 'primary' || color === 'secondary')
        unorderedListStyles.push(styles[color]);
    const customStyles = color !== 'primary' && color !== 'secondary' ? { color } : undefined;
    if (spacing === 'compact')
        unorderedListStyles.push(styles.compact);
    unorderedListStyles.push(rest.className);
    return (jsx("ul", Object.assign({ id: id, className: unorderedListStyles.join(' ').trim(), "aria-label": ariaLabel || arialabel }, (customStyles && { style: customStyles }), { children: children })));
};
UnorderedList.displayName = 'UnorderedList';

export { UnorderedList, UnorderedList as default };
